import React, { Component } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import SearchControls from "./SearchControls";

class AdvanceSearchControl extends Component {
  state = {
    activeIndex: 0,
  };
  componentDidMount() {}

  handleClick = (e, index) => {
    let newIndex = index;
    if (index === this.state.activeIndex) {
      newIndex = -1;
    }
    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const { isLeftSearch } = this.props;
    return (
      <Accordion
        fluid
        styled
        style={{
          marginTop: "3px",
          marginBottom: "3px",
          paddingLeft: "0",
          paddingRight: "0",
        }}
      >
        <Accordion.Title
          active={activeIndex === 0}
          key={"AdvanceSearchTitle"}
          className={"advance-search-title"}
          onClick={(e) => this.handleClick(e, 0)}
        >
          <Icon name="dropdown" />
          Search
        </Accordion.Title>
        <Accordion.Content
          key="AdvaceSearch"
          active={activeIndex === 0}
          className={!isLeftSearch && "form-advance-controls"}
        >
          <SearchControls
            {...this.props}
            formControls={this.props.formControls}
          />
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default AdvanceSearchControl;



// WEBPACK FOOTER //
// ./src/components/searches/AdvanceSearchControl.js